/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  AuthResponse,
  EntraCallbackRequest,
  LogoutRequest,
  MagicLinkValidateRequest,
  RefreshTokenRequest,
  RegisterRequest,
  RegisterResponse,
  UserDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type entraCallbackV1Response200 = {
  data: AuthResponse
  status: 200
}

export type entraCallbackV1Response401 = {
  data: void
  status: 401
}

export type entraCallbackV1ResponseSuccess = (entraCallbackV1Response200) & {
  headers: Headers;
};
export type entraCallbackV1ResponseError = (entraCallbackV1Response401) & {
  headers: Headers;
};

export type entraCallbackV1Response = (entraCallbackV1ResponseSuccess | entraCallbackV1ResponseError)

export const getEntraCallbackV1Url = () => {




  return `/api/v1/auth/entra/callback`
}

export const entraCallbackV1 = async (entraCallbackRequest: EntraCallbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<entraCallbackV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<entraCallbackV1Response>(getEntraCallbackV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(entraCallbackRequest)
  }
);}


export type logoutV1Response204 = {
  data: void
  status: 204
}

export type logoutV1Response400 = {
  data: void
  status: 400
}

export type logoutV1Response401 = {
  data: void
  status: 401
}

export type logoutV1ResponseSuccess = (logoutV1Response204) & {
  headers: Headers;
};
export type logoutV1ResponseError = (logoutV1Response400 | logoutV1Response401) & {
  headers: Headers;
};

export type logoutV1Response = (logoutV1ResponseSuccess | logoutV1ResponseError)

export const getLogoutV1Url = () => {




  return `/api/v1/auth/logout`
}

/**
 * Revokes the current session. Tokens issued for this session are no longer accepted.
 */
export const logoutV1 = async (logoutRequest: LogoutRequest, options?: Parameters<typeof customFetch>[1]): Promise<logoutV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<logoutV1Response>(getLogoutV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(logoutRequest)
  }
);}


export type validateMagicLinkV1Response200 = {
  data: AuthResponse
  status: 200
}

export type validateMagicLinkV1Response401 = {
  data: void
  status: 401
}

export type validateMagicLinkV1ResponseSuccess = (validateMagicLinkV1Response200) & {
  headers: Headers;
};
export type validateMagicLinkV1ResponseError = (validateMagicLinkV1Response401) & {
  headers: Headers;
};

export type validateMagicLinkV1Response = (validateMagicLinkV1ResponseSuccess | validateMagicLinkV1ResponseError)

export const getValidateMagicLinkV1Url = () => {




  return `/api/v1/auth/magic-link/validate`
}

export const validateMagicLinkV1 = async (magicLinkValidateRequest: MagicLinkValidateRequest, options?: Parameters<typeof customFetch>[1]): Promise<validateMagicLinkV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<validateMagicLinkV1Response>(getValidateMagicLinkV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(magicLinkValidateRequest)
  }
);}


export type getCurrentUserV1Response200 = {
  data: UserDto
  status: 200
}

export type getCurrentUserV1Response401 = {
  data: void
  status: 401
}

export type getCurrentUserV1Response404 = {
  data: void
  status: 404
}

export type getCurrentUserV1ResponseSuccess = (getCurrentUserV1Response200) & {
  headers: Headers;
};
export type getCurrentUserV1ResponseError = (getCurrentUserV1Response401 | getCurrentUserV1Response404) & {
  headers: Headers;
};

export type getCurrentUserV1Response = (getCurrentUserV1ResponseSuccess | getCurrentUserV1ResponseError)

export const getGetCurrentUserV1Url = () => {




  return `/api/v1/auth/me`
}

export const getCurrentUserV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getCurrentUserV1Response> => {

  return customFetch<getCurrentUserV1Response>(getGetCurrentUserV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type refreshTokenV1Response200 = {
  data: AuthResponse
  status: 200
}

export type refreshTokenV1Response401 = {
  data: void
  status: 401
}

export type refreshTokenV1ResponseSuccess = (refreshTokenV1Response200) & {
  headers: Headers;
};
export type refreshTokenV1ResponseError = (refreshTokenV1Response401) & {
  headers: Headers;
};

export type refreshTokenV1Response = (refreshTokenV1ResponseSuccess | refreshTokenV1ResponseError)

export const getRefreshTokenV1Url = () => {




  return `/api/v1/auth/refresh`
}

export const refreshTokenV1 = async (refreshTokenRequest: RefreshTokenRequest, options?: Parameters<typeof customFetch>[1]): Promise<refreshTokenV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<refreshTokenV1Response>(getRefreshTokenV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshTokenRequest)
  }
);}


export type registerV1Response201 = {
  data: RegisterResponse
  status: 201
}

export type registerV1Response400 = {
  data: RegisterResponse
  status: 400
}

export type registerV1Response409 = {
  data: RegisterResponse
  status: 409
}

export type registerV1Response502 = {
  data: RegisterResponse
  status: 502
}

export type registerV1ResponseSuccess = (registerV1Response201) & {
  headers: Headers;
};
export type registerV1ResponseError = (registerV1Response400 | registerV1Response409 | registerV1Response502) & {
  headers: Headers;
};

export type registerV1Response = (registerV1ResponseSuccess | registerV1ResponseError)

export const getRegisterV1Url = () => {




  return `/api/v1/auth/register`
}

/**
 * Self-service registration. Blocks if user already exists in Entra. Creates Entra + Salesforce + local accounts.
 */
export const registerV1 = async (registerRequest: RegisterRequest, options?: Parameters<typeof customFetch>[1]): Promise<registerV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<registerV1Response>(getRegisterV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerRequest)
  }
);}


